"use strict";
/*
 * Created on 01 16 2019
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DateParser_1 = require("../../core/model/data-dictionary/parsers/DateParser");

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var DomainObject_1 = require("../../core/model/DomainObject");
/**
 * Binding of {@link VAT value added tax} to {@link Product internal product}. Validity of binding is based
 * on validity of {@link VAT.rates rates of value added tax}.
 *
 * Note: source for those bindings can differ across multiple clients, e.g. client can model this explicitly or it should be
 * derived from some other data, e.g. price lists.
 *
 * @author JMe
 */


var ProductVAT =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(ProductVAT, _DomainObject_1$Domai);

  /**
   * @param id the internal id of entity
   * @param productId the internal id of product
   * @param vatId the internal id of {@link VAT vat entity}, use it to lookup for rates.
   * @param validFrom the start date of validity (corresponds with validity of {@link VATRate.rate})
   * @param validTo the end date of validity (corresponds with validity of {@link VATRate.rate})
   */
  function ProductVAT(id, productId, vatId, validFrom, validTo) {
    var _this;

    _classCallCheck(this, ProductVAT);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ProductVAT).call(this));
    _this.id = id;
    _this.productId = productId;
    _this.vatId = vatId;
    _this.validFrom = validFrom;
    _this.validTo = validTo;
    return _this;
  }
  /**
   * Converter from data-dictionary representation
   */


  _createClass(ProductVAT, null, [{
    key: "fromDataDict",
    value: function fromDataDict(mat) {
      return new ProductVAT(mat.id, mat.productId, mat.vatId, mat.validFrom, mat.validTo);
    }
  }]);

  return ProductVAT;
}(DomainObject_1.DomainObject);

exports.ProductVAT = ProductVAT;

ProductVAT.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(ProductVAT.name);
  return {
    id: builder.id('id'),
    productId: builder.id('productId'),
    vatId: builder.id('vatId'),
    validFrom: builder.date('validFrom', DateParser_1.DateParser.ISO_PATTERN),
    validTo: builder.date('validTo', DateParser_1.DateParser.ISO_PATTERN)
  };
}();